export const ClientSharedValues = {
    lstatSync: () => { },
};
